import { Link, useLoaderData } from 'react-router-dom';
import { Button, Table } from 'antd';
import { useTranslation } from 'react-i18next';

import type { UnitsLoaderType } from './queries';
import type { IUnit } from './types';

import { useUnitsQuery } from './queries';
import { usePagination } from '@/hooks/usePagination';
import { useColumns } from './useColumns';
import { routes } from '@/app/router/routes';

import { PageHeader } from '@/ui/PageHeader';

export const Units = () => {
  const { t } = useTranslation();
  const initialData = useLoaderData() as UnitsLoaderType;
  const { data: units, isLoading } = useUnitsQuery(initialData);

  return (
    <>
      <PageHeader
        title={t('units.title')}
        description={t('units.description')}
        extra={
          <Link to={routes.unitCreate()}>
            <Button type='primary'>{t('units.createButtonText')}</Button>
          </Link>
        }
      />
      <Table<IUnit>
        rowKey='id'
        dataSource={units.data ?? []}
        loading={isLoading}
        columns={useColumns()}
        pagination={usePagination(units.total, units.per_page)}
        scroll={{ x: 'max-content' }}
      />
    </>
  );
};
